import { render, staticRenderFns } from "./infoscan.vue?vue&type=template&id=4cc4b40f&scoped=true&lang=pug"
import script from "./infoscan.vue?vue&type=script&lang=js"
export * from "./infoscan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4b40f",
  null
  
)

/* custom blocks */
import block0 from "./infoscan.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports